export const authMenu = {
	login: {
		id: 'login',
		text: 'Login',
		path: '/login',
		hide: true,
	},
	confirmLogin: {
		id: 'confirmLogin',
		text: 'Please Verify Your account',
		path: '/login/secured/2fa',
		hide: true,
	},
	joinTeam: {
		id: 'accept_invitation',
		text: 'Join MeVerify Team',
		path: '/accept_invitation',
		hide: true,
	},
	profile: {
		id: 'profile',
		text: 'My Profile',
		path: '/profile',
		hide: true,
	},
	forgetGroup: {
		id: 'forget',
		text: 'Reset Password',
		hide: true,
		subMenu: {
			forgetPassword: {
				id: 'forgetPassword',
				text: 'Get Help',
				path: '/forget-password',
				hide: true,
			},
			confirmation: {
				id: 'confirmation',
				text: 'Verify your account',
				path: '/reset-verification',
				hide: true,
			},
			resetPassword: {
				id: 'reset',
				text: 'Reset your password now',
				path: '/reset-password',
				hide: true,
			},
		},
	},
};

export const dashboardMenu = {
	dashboard: {
		id: 'dashboard',
		text: 'Dashboard',
		path: '/',
		icon: 'Dashboard',
		permission: 'view dashboard',
		subMenu: null,
	},
	systemApiKeys: {
		id: 'systemApiKeys',
		text: 'System Api Keys',
		path: '/system-api-keys',
		icon: 'VpnKey',
		permission: 'view system api keys',
	},
	users: {
		id: 'users',
		text: 'Users',
		path: '/users',
		icon: 'Person',
		permission: 'view users',
		subMenu: null,
	},
	customers: {
		id: 'customers',
		text: 'Customers',
		path: '/customers',
		icon: 'AccountCircle',
		permission: 'view customers',
		subMenu: null,
	},
	transactions: {
		id: 'transactions',
		text: 'Transactions',
		path: '/transactions',
		icon: 'ShowChart',
		permission: 'view transactions',
		subMenu: null,
	},
	currencies: {
		id: 'currencies',
		text: 'Currencies',
		path: '/currencies',
		icon: 'Payments',
		permission: 'view currencies',
		subMenu: null,
	},
	invoices: {
		id: 'invoices',
		text: 'Invoices',
		path: '/invoices',
		icon: 'ProductionQuantityLimits',
		permission: 'view invoices',
		subMenu: null,
	},
	wallets: {
		id: 'wallets',
		text: 'Wallets',
		path: '/wallets',
		icon: 'AccountBalanceWallet',
		permission: 'view wallets',
		subMenu: null,
	},
};

export const institutions = {
	institutions: {
		id: 'institutions',
		text: 'Institutions',
		permission: 'view companies',
		icon: 'Extension',
	},
	companies: {
		id: 'companies',
		text: 'Company',
		path: '/institutions/companies',
		permission: 'view companies',
		icon: 'Tonality',
	},
	projects: {
		id: 'projects',
		text: 'Projects',
		path: '/institutions/projects',
		permission: 'view projects',
		icon: 'Terrain',
	},
	verifications: {
		id: 'verifications',
		text: 'Identity Verifications',
		path: '/institutions/identity-verifications',
		permission: 'view api calls',
		icon: 'BackHand',
	},
};

export const products = {
	productcats: {
		id: 'products',
		text: 'Products',
		icon: 'Extension',
		permission: 'view products',
	},
	products: {
		id: 'products',
		text: 'Products',
		path: '/products',
		icon: 'VerticalDistribute',
		permission: 'view products',
	},
	plan: {
		id: 'plans',
		text: 'Plans',
		path: '/plans',
		icon: 'AutoAwesomeMotion',
		permission: 'view plans',
	},
	customerPlans: {
		id: 'customer-plans',
		text: 'Customer Plans',
		path: '/customer-plans',
		icon: 'StackedBarChart',
		permission: 'view customer plans',
	},
};

export const administrations = {
	administrations: {
		id: 'administrations',
		text: 'Administrations',
		icon: 'Extension',
		permission: 'view administrations',
	},
	roles: {
		id: 'roles',
		text: 'Roles',
		path: '/administrations/roles',
		icon: 'Login',
		permission: 'view roles',
	},
	staff: {
		id: 'staff',
		text: 'Staff',
		path: '/administrations/staff',
		icon: 'PersonAdd',
		permission: 'view administrators',
	},
};
